import {
    ConfigurationItemArrayEditor,
    configurationItemArrayEditorRules,
} from '@client/components/_core/configuration/ConfigurationItemArrayEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Col, Row } from 'antd';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/documents')({
    staticData: {
        metadata: {
            title: 'Documents',
        },
        ui: {
            title: 'Claims configuration',
        },
    },
    component: Documents,
});

function Documents() {
    return (
        <PageController route={Route}>
            <Row>
                <Col span={12}>
                    <ConfigurationItemArrayEditor
                        title="Claim document types"
                        settingToEdit="CLAIM_UPLOAD_DOCUMENT_TYPES"
                        description="Rename, add or remove an upload document type."
                        minItems={1}
                        arrayRules={[configurationItemArrayEditorRules.uniqueItems]}
                        itemRules={[{ required: true, message: 'Field is required' }]}
                        className="h-full"
                    />
                </Col>
            </Row>
        </PageController>
    );
}
